import {ErrorCallback, postData, SuccessCallback} from '../../common/services/network.service';
import {ContactUsFormHelpOptions} from './constants';
import {sendSalesforceLead} from '../../salesforceIntegration/data/service';
import {ContactUsFormErrors, ContactUsFormValues, SalesforceConfig, SelectOption} from "../../common/models/common.models";

type FormValidationResult = {
    isValid: boolean;
    errors: Partial<ContactUsFormErrors>;
}

export const validateForm = (values: ContactUsFormValues): FormValidationResult => {
    let isValid = true;
    let errors: ContactUsFormErrors = {};
    if (!values.firstName?.trim()) {
        isValid = false;
        errors.firstName = {
            message: 'First name is required',
        };
    }

    if (!values.lastName?.trim()) {
        isValid = false;
        errors.lastName = {
            message: 'Last name is required',
        };
    }

    if (!values.companyName?.trim()) {
        isValid = false;
        errors.companyName = {
            message: 'Company name is required',
        };
    }

    if (!values.email?.trim()) {
        isValid = false;
        errors.email = {
            message: 'Email is required',
        };
    } else if (
        !/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])/.test(
            String(values.email).toLowerCase()
        )
    ) {
        isValid = false;
        errors.email = {
            message: 'Email is invalid',
        };
    }

    if (!values.helpCategory) {
        isValid = false;
        errors.helpCategory = {
            message: 'Help category is required',
        };
    }

    if (!values.industry) {
        isValid = false;
        errors.industry = {
            message: 'Industry field is required',
        };
    }

    if (!values.helpDescription?.trim()) {
        isValid = false;
        errors.helpDescription = {
            message: 'Help description is required',
        };
    }

    return {
        isValid,
        errors,
    };
};

const handleSendSalesforceLead = (formValues: ContactUsFormValues, helpOption: SelectOption, salesForceConfig: SalesforceConfig) => {
    if (
        salesForceConfig ||
        helpOption.value === ContactUsFormHelpOptions.REQUEST_ADVANCED_LICENSE ||
        helpOption.value === ContactUsFormHelpOptions.REQUEST_STANDARD_LICENSE
    ) {
        sendSalesforceLead(salesForceConfig?.formName, {
            helpCategory: formValues.helpCategory,
            industry: formValues.industry,
            firstName: formValues.firstName,
            lastName: formValues.lastName,
            email: formValues.email,
            phone: '',
            companyName: formValues.companyName,
            helpDescription: formValues.helpDescription,
        });
    }
};

export const submitForm = (
    values: ContactUsFormValues,
    helpOption: SelectOption,
    onSuccess: SuccessCallback,
    onError: ErrorCallback,
    baseUrl: string = '',
    salesForceConfig: SalesforceConfig
) => {
    const { firstName, lastName, email, phone, companyName, helpCategory, helpDescription, industry } = values;

    const onSubmitSuccessCallback = () => {
        handleSendSalesforceLead(values, helpOption, salesForceConfig);
        onSuccess?.();
    };

    return postData(
        `${baseUrl}ContentProvider/SendContactUsMail`,
        JSON.stringify({
            topic: helpCategory,
            explanation: helpDescription,
            phoneNumber: phone,
            companyName,
            email,
            firstName,
            lastName,
            industry,
        }),
        onSubmitSuccessCallback,
        onError
    );
};
